var HELP_CENTER_APPLICATION_NAME = 'help-center-page';
var SEARCH_BAR_FLYOUT_APPLICATION_NAME = 'SearchBarFlyout';
var RECENT_SEARCHES_KEY = 'recentSearches';

export { HELP_CENTER_APPLICATION_NAME, RECENT_SEARCHES_KEY, SEARCH_BAR_FLYOUT_APPLICATION_NAME };
//# sourceMappingURL=constants.js.map
